<script>
    import DesktopButton2 from '../../reusableitems/DesktopButton2.svelte';
</script>

<section>
    <div class="main-div">
        <div class="images-div">
            <div class="mobile-div">
                <img
                    src="images/Perfomance/Group1000002574.png"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
            <div class="back-div">
                <img
                    src="images/Perfomance/back2.svg"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
            <div class="Number">
                <p>2</p>
            </div>
            <div class="text-div">
                <p>Performers & Opus</p>
                <p>Motion Recording Artists</p>
                <p>The stage is the play.</p>
                <p>
                    Bringing realism to a production requires more than just the
                    main characters. From background crowds to that gnarly
                    character making a single time appearance, it takes a lot to
                    tell a story effectively.
                </p>
                <p>
                    You don’t have to be an actor to record motions. The
                    symphony is in the variety of motions from everyone
                </p>
                <p>
                    Our
                    <span style="color:#1C7BFF ;font-weight:600;"> <u>motion recording app</u></span> turns
                    a simple smartphone into a production capture studio.
                </p>
                <p>
                    Be the part of early adopters, vote on what features you
                    would like to see first or simply join the discussion on the
                    future of democratized entertainment.
                </p>
                <div class="btn-div">
                    <DesktopButton2
                        state = "Performer"
                        width="24.074vh"
                        text1 = "Join Artist Governace Council"
                        text2="(Actor Seat)"
                        AnimationColor="black"
                        TextColorAfter="#67eebb"
                        BorderColorAfter="black"
                        text3="15"
                    />
                </div>
            </div>
        </div>
       
    </div>
</section>

<style>
    .main-div {
        width: 138.796vh;
        height: 100vh;
        overflow: hidden;
        position: relative;
    }
    .images-div {
        display: flex;
        position: relative;
        width: 138.796vh;
        height: 100vh;
    }
    .back-div {
        position: absolute;
        right: 0vh;
        width: 101.852vh;
        height: 100vh;
        pointer-events:none ;
        z-index: -1;
    }
    .Number{
        position: absolute;
        top: -6.229vh;
        left: 46.5vh;
        z-index: -1;
    }
    .Number p{
        margin: 0;
        font-weight: 700;
        font-size: 27.778vh;
        line-height: 27.778vh;
        color: rgba(255, 255, 255, 0.6);
        font-family: 'Orbitron';
    }
    .mobile-div {
        left: -20vh;
        position: absolute;
        width: 108.611vh;
        height: 100vh;
        top: 6vh;
        pointer-events: none;
        transform: scale(0.95);
    }
    .text-div {
        position: absolute;
        right: 15.648vh;
        width: 50.093vh;
        font-family: "Orbitron";
        top: 7.222vh;
    }
    .text-div p:nth-child(1) {
        font-size: 1.296vh;
        letter-spacing: 0.058vh;
        font-weight: 400;
        text-transform: uppercase;
    }
    .text-div p:nth-child(2) {
        font-size: 5.556vh;
        line-height: 5.556vh;
        margin-top: 1.759vh;
        margin-bottom: 4.167vh;
        letter-spacing: 0.058vh;
        font-weight: 700;
        text-transform: uppercase;
    }
    .text-div p:nth-child(3) {
        margin-top: 2.315vh ;
        font-size: 1.852vh;
        line-height: 2.593vh;
        letter-spacing: 0.058vh;
        font-weight: 700;
    }
    .text-div p:nth-child(4) {
        margin-top: 2.315vh ;
        font-size: 1.852vh;
        line-height: 2.593vh;
        letter-spacing: 0.058vh;
        font-weight: 400;
    }
    .text-div p:nth-child(5) {
        margin-top: 2.315vh ;
        font-size: 1.852vh;
        line-height: 2.593vh;
        font-weight: 400;
        letter-spacing: 0.058vh;
    }
    .text-div p:nth-child(6) {
        margin-top: 2.315vh ;
        font-size: 1.852vh;
        line-height: 2.593vh;
        font-weight: 400;
        letter-spacing: 0.058vh;
    }
    .text-div p:nth-child(7) {
        margin-top: 2.315vh ;
        font-size: 1.852vh;
        line-height: 2.593vh;
        font-weight: 400;
        letter-spacing: 0.058vh;
    }
    .btn-div {
        margin-top: 4.537vh;
    }
</style>
